import React from 'react';
import { Zlogo } from '@fabric-ui/icons';
import { flex } from '@fabric-ui/theme';
import { iconSize } from '@fabric-ui/utils';
import { Box } from '@mui/material';

export const ZscalerLogo = () => (
  <Box
    sx={{
      ...flex.center,
      aspectRatio: '1 / 1',
      backgroundColor: 'var(--color-surface-severity-none-secondary)',
      borderRadius: '100%',
      flexShrink: 0,
      height: 24,
      width: 24,
    }}>
    <Zlogo style={{ ...iconSize(16) }} />
  </Box>
);
